<template>
  <v-card class="mt-2 ml-2 mr-2">
    <FKegiatanMaterialTable ref="refDaftarInventarisTable"></FKegiatanMaterialTable>
  </v-card>
</template>

<script>

import FKegiatanMaterialTable from "@/components/rantai_pasok_bahan/kebutuhan_bahan/FKegiatanMaterialTable";
import ERole from "@/models/e-role";
export default {
  name: "KebutuhanBahanView",
  components: {
    FKegiatanMaterialTable,
  },
  data() {
    return {
    }
  },
  computed:{
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin(){
      console.log([ERole.ROLE_ADMIN, ERole.ROLE_USER].some(
          (x) => this.currentUser.roles.includes(x)))
      return [ERole.ROLE_ADMIN, ERole.ROLE_USER].some(
          (x) => this.currentUser.roles.includes(x));
    },
    isDiklat(){
      return [ERole.ROLE_DIKLAT].some(
          (x) => this.currentUser.roles.includes(x));
    },
    isVendorMP(){
      return [ERole.ROLE_MP].some(
          (x) => this.currentUser.roles.includes(x));
    }
  },
  methods: {

  },


}
</script>

<style scoped>
</style>